import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ToolbarTCentral'),_c(VMain,{staticClass:"ma-0 pa-0"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('MailingList'),_c('SocialMedia'),_c('scroll-to-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }